<div class="nav material">
  <app-tenant-selector> </app-tenant-selector>
  @for (item of navigation; track item.id) {
    @if (item.type === 'group') {
      <app-nav-group [item]="item"></app-nav-group>
    }
    @if (item.type === 'collapsable') {
      <app-nav-collapsable [item]="item"></app-nav-collapsable>
    }
    @if (item.type === 'item') {
      <app-nav-item [item]="item"></app-nav-item>
    }
  }
</div>
